import IdListDTO from 'models/dto/IdListDTO';
import KPIDTO from 'models/dto/kpi/kpiDTO';
import TaskTypeDTO from 'models/dto/tasks/taskTypeDTO';

export class KPIStableMetadataMutationDTO {
  kpiId: number;

  isField: boolean;

  authSchemaId?: number;

  tagIds?: IdListDTO;

  mutationId: string;

  constructor() {
    this.kpiId = 0;
    this.isField = false;
    this.mutationId = '';
  }
}

export class KPIDefinitionPreviewRequestDTO {
  kpi: KPIDTO;

  expectedKpiRowVersion?: string;

  mutationId: string;

  constructor() {
    this.kpi = new KPIDTO();
    this.mutationId = '';
  }
}

export class KPIDefinitionPreviewDTO {
  previewToken: string;

  definitionHash: string;

  kpiId: number;

  currentDefinitionRevisionId: number;

  affectedCatalogFamilyCount: number;

  affectedPrivateOrManagedFamilyCount: number;

  affectedTaskCount: number;

  requiresConfirmation: boolean;

  affectedCatalogFamilyNames: string[];

  inaccessibleCatalogFamilyCount: number;

  compatibilityBlockers: string[];

  constructor() {
    this.previewToken = '';
    this.definitionHash = '';
    this.kpiId = 0;
    this.currentDefinitionRevisionId = 0;
    this.affectedCatalogFamilyCount = 0;
    this.affectedPrivateOrManagedFamilyCount = 0;
    this.affectedTaskCount = 0;
    this.requiresConfirmation = false;
    this.affectedCatalogFamilyNames = [];
    this.inaccessibleCatalogFamilyCount = 0;
    this.compatibilityBlockers = [];
  }
}

export class KPIDefinitionCommitDTO {
  kpi: KPIDTO;

  previewToken: string;

  mutationId: string;

  reason?: string;

  confirmed: boolean;

  constructor() {
    this.kpi = new KPIDTO();
    this.previewToken = '';
    this.mutationId = '';
    this.confirmed = false;
  }
}

export class KPIDefinitionCommitResultDTO {
  kpi: KPIDTO;

  kpiDefinitionRevisionId: number;

  updatedTaskTypes: TaskTypeDTO[];

  constructor() {
    this.kpi = new KPIDTO();
    this.kpiDefinitionRevisionId = 0;
    this.updatedTaskTypes = [];
  }
}

export class KPIDefinitionRevisionChoiceDTO {
  choiceKey: number;

  sortOrder: number;

  value?: string;

  description?: string;

  constructor() {
    this.choiceKey = 0;
    this.sortOrder = 0;
  }
}

export class KPIDefinitionRevisionInfoDTO {
  kpiId: number;

  kpiDefinitionRevisionId: number;

  revision: number;

  isCurrent: boolean;

  type: number;

  minValue?: string;

  maxValue?: string;

  decimalCount: number;

  defValue?: string;

  required: boolean;

  attachmentMode?: number;

  commentMode?: number;

  showLabel: boolean;

  source: number;

  actorId?: string;

  created: string;

  name?: string;

  description?: string;

  instruction?: string;

  expectedResult?: string;

  choices: KPIDefinitionRevisionChoiceDTO[];

  constructor() {
    this.kpiId = 0;
    this.kpiDefinitionRevisionId = 0;
    this.revision = 0;
    this.isCurrent = false;
    this.type = 0;
    this.decimalCount = 0;
    this.required = false;
    this.showLabel = false;
    this.source = 0;
    this.created = '';
    this.choices = [];
  }
}

export class KPIDefinitionTextCorrectionMutationDTO {
  kpiId: number;

  kpiDefinitionRevisionId: number;

  choiceKey?: number;

  languageId: number;

  name?: string;

  description?: string;

  instruction?: string;

  expectedResult?: string;

  choiceValue?: string;

  question?: string;

  expectedDefinitionRevisionRowVersion?: string;

  expectedImpactHash?: string;

  mutationId: string;

  constructor() {
    this.kpiId = 0;
    this.kpiDefinitionRevisionId = 0;
    this.languageId = 0;
    this.mutationId = '';
  }
}
